<template>
  <div class="gallary-content-area mv-h-full position-relative d-flex">
    <v-container class="mv-h-full ml-10">
      <mvWdGallaryInputVue />
    </v-container>
    <v-container class="mv-h-full">
      <mvWdGallaryOutputVue></mvWdGallaryOutputVue>
    </v-container>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)

//例如: import <组件名称> from  <组建路径>
import mvWdGallaryInputVue from "./widgets/mv-wd-gallary-input.vue";
import mvWdGallaryOutputVue from "./widgets/mv-wd-gallary-output.vue";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    mvWdGallaryInputVue,
    mvWdGallaryOutputVue,
  },
  props: {},
  data() {
    //这里存放数据
    return {};
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {},
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {},
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss">
@import "~@/styles/apps/gallary.scss";
</style>
